import {
	CalendarCommonModule,
	CalendarDateFormatter,
	CalendarMonthModule,
	ɵCalendarMonthViewHeaderComponent as CalendarMonthViewHeaderComponent,
} from 'angular-calendar';
import { WeekDay } from 'calendar-utils';
import { takeUntil } from 'rxjs';

import { NgClass, NgForOf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { LayoutService } from '@layout/services/layout/layout.service';
import {
	CustomDateFormatterService,
	monthViewColumnHeader,
	monthViewColumnHeaderMobile,
} from '@schedule/lib/services/calendar-date-formatter/custom-date-formatter.service';
import { CalendarColumnHeaderClickedEvent } from '@schedule/lib/types/calendar.types';

@Component({
	selector: 'app-calendar-month-headers',
	imports: [CalendarMonthModule, NgClass, CalendarCommonModule, NgTemplateOutlet, NgForOf],
	providers: [
		{
			provide: CalendarDateFormatter,
			useClass: CustomDateFormatterService,
		},
	],
	templateUrl: './calendar-month-headers.component.html',
	styleUrl: './calendar-month-headers.component.scss',
})
export class CalendarMonthHeadersComponent extends CalendarMonthViewHeaderComponent implements OnInit, OnDestroy {
	destroyed$ = new EventEmitter<void>();
	isMobileSize = true;
	private layoutService = inject(LayoutService);

	headerCalendarDateMethod = monthViewColumnHeader;

	@Input() override days: WeekDay[];

	@Input() override locale: string;

	// Don't allow the custom template
	override customTemplate: TemplateRef<unknown>;

	@Input() override trackByWeekDayHeaderDate: (index: number, day: WeekDay) => string;

	@Output() override columnHeaderClicked = new EventEmitter<CalendarColumnHeaderClickedEvent>();

	ngOnInit(): void {
		this.layoutService.isMobileSize$.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
			this.isMobileSize = value;
			this.headerCalendarDateMethod = this.isMobileSize ? monthViewColumnHeaderMobile : monthViewColumnHeader;
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}
}
